'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _tabs = require('./tabs');

var _tabs2 = _interopRequireDefault(_tabs);

var _flipper = require('./flipper');

var _flipper2 = _interopRequireDefault(_flipper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.ui', [_tabs2.default, _flipper2.default]).name;

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/ui/index.js
 **/